import Spacing from 'components/Spacing';

import CarriedInterestPartnerSettings from './CarriedInterestPartnerSettings';
import { useLayoutContext } from 'contexts/LayoutContext';
import PageLoader from 'components/PageLoader';
import GridContainer from 'components/GridContainer';
import { Grid } from '@mui/material';
import OverallCarriedInterestSettings from './OverallCarriedInterestSettings';
import CarriedInterestFeeTemplates from './CarriedInterestFeeTemplates';

const CarrySettings: React.FC = () => {
  const { vehicle } = useLayoutContext();

  if (!vehicle) return <PageLoader />;

  return (
    <GridContainer>
      <Grid size={{ xs: 12, xl: 8 }}>
        <Spacing>
          <OverallCarriedInterestSettings vehicle={vehicle} />
          <CarriedInterestFeeTemplates vehicle={vehicle} />
          <CarriedInterestPartnerSettings vehicle={vehicle} />
        </Spacing>
      </Grid>
    </GridContainer>
  );
};

export default CarrySettings;
